const fr = {
  NOTIFICATION: {
    TITLE: 'Notifications',
    DEPART: 'Lorsqu\'un collaborateur quitte votre entité, n\'oubliez pas de déclarer son départ.',
    EMPTY: 'Vous n\'avez pas de notifications.',
  },
  SEARCH: {
    DOMAINES: "Rechercher un domaine d'activité",
    LANGUAGES: 'Rechercher une langue',
    NAME: 'Rechercher par nom, prénom ...',
    NAME_TEL: 'Rechercher par nom, prénom, téléphone ...',
  },
  ACTIVATION: {
    RECUPERATION_MAIL: 'Indiquez un email de récupération de compte',
    ACTIVATE: 'Activer mon identité',
    MAIL_GOAL: 'Cet email a pour but de vous permettre de récupérer votre compte en cas d\'oubli de votre pseudo ou de votre mot de passe.',
    MAIL: 'Email de récupération de compte',
    CONDITIONS: 'J\'ai lu et j\'accepte les ',
    CONDITIONS_LINK: 'conditions générales d\'utilisation',
    UNIQUE_ACCESS_MAIL: 'Votre email doit être une adresse à laquelle vous seul avez accès. ',
    WONT_BE_USED_MAIL: 'Il ne sera pas utilisé à d\'autre fins.',
    TITLE: 'Activation de mon identité numérique',
    ENTER_ID: 'Saisissez vos identifiants d\'activation',
    ACTIVATION_ID: 'Identifiants d\'activation',
    ACTIVATION_CODE: 'Code d\'activation',
    BIRTHDATE: 'Date de naissance',
    LETTER: 'Munissez-vous du pli scellé que le Conseil supérieur du notariat vous a transmis.',
    NO_LETTER: 'Je n\'ai pas reçu de courrier',
    DEFINE_IDS: 'Définissez vos identifiants de connexion',
    PSEUDO: 'Identifiant de connexion',
    PASSWORD: 'Mot de passe',
    CONFIRME: 'Confirmer',
    CONFIDENTIAL_IDS: 'Toutes vos informations de connexion sont confidentielles et personnelles. Ne les communiquez en aucun cas.',
    RENVOI_SUCCESS: 'Votre demande a bien été transmise à l\'administrateur de votre compte professionnel.',
    EXISTING_ACCOUNT: 'Compte existant',
    REMOVE_DUPLICATE: 'Le système a détecté que vous possédez déjà un compte de collaborateur.',
    REMOVE_DUPLICATE_2: 'Vous devez procéder à la suppression de ce compte avant d\'activer votre compte de notaire en cliquant sur le bouton "Poursuivre".',
    THANKS: 'Merci %{prenom} %{nom},',
    RENSEND_EMAIL: 'Renvoyer un email',
    FULL_NAME: '%{prenom} %{nomUsuel} (né(e) %{nomDeNaissance})',
    FIRST_AND_LAST_NAME: '%{prenom} %{nomUsuel}',
    PERSONAL_EMAIL: 'Email personnel : %{email}',
    RESCUE_EMAIL: 'Email de secours : %{email}',
    CREATED_WHEN: 'Crée le %{date}',
    RATTACHMENTS: 'Rattachements :',
    EXISTING_ACCOUNT_HINT: 'La suppression de votre compte collaborateur sera effective dès lors que votre compte de notaire sera activé',
    DELETE_AND_END: 'Poursuivre',
  },
  BUREAU: {
    PRINCIPAL: 'Bureau principal',
    ANNEXE: 'Bureau annexe',
    ANNEXES: 'Bureau annexe de %{ville}',
    ANNEXES_FALLBACK: 'Bureau annexe %{number}',
  },
  GENDER: {
    male: 'Monsieur',
    female: 'Madame',
  },
  NO_LETTER: {
    POPIN_TEXT: 'Vous n’avez pas reçu votre code d’activation par courrier ?',
    POPIN_SUBTEXT: 'Si vous êtes notaire (titulaire, associé, salarié) ou secrétaire général d’instance, vous pouvez demander à vous faire renvoyer votre code personnel d’activation.',
    ACTION: 'Demander mon code',
    TITLE: 'Demande de renvoi des codes d’activation',
    SUBTITLE1: 'Vous êtes notaire ou secrétaire général d’instance.',
    SUBTITLE2: 'Vous n’avez pas reçu votre code d’activation de compte professionnel par courrier.',
    SUBTITLE3: 'Signalez-le nous !',
    NAME: 'Nom usuel',
    FIRSTNAME: 'Prénom',
    CRPCEN: 'Code CRPCEN de votre office',
    EMAIL: 'Email de contact',
    PHONE: 'Téléphone',
    SEND: 'Envoyer ma demande',
  },
  CREATION: {
    TITLE: 'Création de mon identité numérique',
    ENTER_ID: 'Indiquez vos informations d\'identité',
    NAME: 'Nom usuel',
    FIRSTNAME: 'Prénom',
    BIRTHNAME: 'Nom de naissance',
    BIRTHDATE: 'Date de naissance',
    BIRTH_CITY: 'Commune de naissance',
    BIRTH_COUNTRY: 'Pays de naissance',
    UNIQUE_ID: 'Ces informations définissent votre identité et nous permettent de vous identifier de manière unique.',
    STRUCTURE_PRO: 'Indiquez votre structure professionnelle',
    VALIDATE_STRUCTURE_PRO: 'Validez la structure professionnelle',
    FIND_STRUCTURE: 'Trouver ma structure professionnelle',
    FIND_OTHER_STRUCTURE: 'Ajouter une autre structure',
    RATTACHEMENT_INFO: 'Afin de pouvoir utiliser votre compte dans un environnement professionnel, il est nécessaire de le rattacher à au moins une structure professionnelle. Vous aurez la possibilité d\'en ajouter ultérieurement.',
    RATTACHEMENT: 'Rattachez votre compte à une structure professionnelle afin de bénéficier des services offerts par la profession.',
    VALIDATE_RATTACHEMENT: 'Vous allez être associé à la structure suivante :',
    MAIL_TEXT: 'Un mail de demande de rattachement va être envoyé au gestionnaire de votre structure. Vérifiez que vous avez sélectionné la bonne.',
    CREATE: 'Créer mon identité',
  },
  END_FORM: {
    CREATION_TITLE: 'Votre identité est presque créée !',
    ACTIVATION_TITLE: 'Votre identité est presque activée !',
    CREATION_SUBTITLE: 'Validez votre email pour finaliser sa création.',
    ACTIVATION_SUBTITLE: 'Validez votre email pour finaliser son activation.',
    INSTRUCTION: 'Cliquez sur le lien dans le mail envoyé à ',
    TEXT1: 'Ce lien est valable 1 heure.',
    TEXT2: 'Si vous ne voyez pas ce message, pensez à vérifier vos spams.',
    ACTION: 'Se connecter',
  },
  END_FORM_CREATED: {
    CREATION_TITLE: 'Votre compte vient d\'être créé !',
    CREATION_SUBTITLE: 'Vous êtes désormais rattaché à la structure ',
    INFORMATION_SUBTITLE: 'Vous allez recevoir un mail d\'information.',
  },
  ADD_STRUCTURE: {
    SEARCH_PLACEHOLDER: 'Rechercher un nom d\'entité, d\'office, un CRPCEN...',
  },
  INTERMEDIARY: {
    COLLABORATOR: 'Je suis collaborateur',
    NOTARY: 'Je suis notaire',
    ACTIVATE: 'Activer mon identité',
    CREATE: 'Créer mon identité',
    SECTION_TITLE1: ' À quoi sert mon identité numérique ?',
    SECTION_TITLE2: 'Les applications de la profession',
    ONE_ACCOUNT: 'Toutes mes applications notariales avec un seul compte',
    SIMPLICITY: 'Une gestion simplifiée de mes données personnelles',
    SECURITY: 'Une authentification centralisée et sécurisée',
  },
  HELPER: {
    MINUSCULE: 'Au moins une minuscule',
    MAJUSCULE: 'Au moins une majuscule',
    NUMBER: 'Au moins un chiffre',
    SPECIAL: 'Au moins un caractère spécial',
    LENGTH: 'Au moins 12 caractères',
  },
  HEADER: {
    MY_ID: 'Mon identité numérique notariale',
    UNIQUE_ACCOUNT: 'Un compte unique pendant toute ma carrière professionnelle',
    RATTACHEMENT_DEMAND: 'Demandes de rattachement',
    CONNECTION: 'Connexion',
    GET_UNIQUE_ACCOUNT: 'Obtenir mon identité numérique',
    MYACCOUNT: 'Mon compte',
    DISCONNECT: 'Déconnexion',
    NOTACCESS: 'Portail Réal - Services',
    VERIFY_MAIL: 'Vérification d\'email',
    notaccess: 'Portail Réal - Services',
  },
  ERROR: {
    LOGIN_ERROR_PART1: 'Une erreur s\'est produite lors de la connexion à l\'application.',
    LOGIN_ERROR_PART2: 'Vous pouvez tenter de vous connecter ultérieurement.',
  },
  VERIFY_EMAIL: {
    EMAIL_SENT: 'Un e-mail vient d\'être envoyé à %{mail}.',
    CLICK_ON_LINK: 'Cliquez sur le lien dans l\'e-mail pour confirmer l\'activation de votre compte.',
  },
  FOOTER: {
    HELP: 'Aide',
    CGU: "Conditions générales d'utilisation",
    CHARTE: 'Charte éthique',
    TITRE: '©2021 Conseil supérieur du notariat',
  },
  STATIC: {},
  CONNECTION_INFORMATION: {
    CONFIDENTIAL: "Assurez-vous qu'elles restent confidentielles.",
    CONFIRM_CLOSE: 'Si vous quittez cette page, les changements apportés à vos informations de connexion seront annulés.',
    CONNECTION_ID: 'Identifiant de connexion',
    CONNECTION_INFORMATION: 'Informations de connexion',
    PASSWORD: 'Mot de passe',
    PASSWORD_CURRENT: 'Mot de passe actuel',
    PASSWORD_NEW: 'Nouveau mot de passe',
    PASSWORD_PLACEHOLDER: '********',
    SUCCESS_ID: 'Votre identifiant a été mis à jour',
    SUCCESS_PASSWORD: 'Votre mot de passe a été mis à jour',
    SEE_PERSONAL_INFO: 'Consulter mes données personnelles',
    UPDATE_PERSONAL_INFO: 'Mettre à jour mes données personnelles',
  },
  PERSONAL_INFORMATION: {
    BIRTH_COUNTRY: 'PAYS DE NAISSANCE :',
    BIRTH_DATE: 'DATE DE NAISSANCE :',
    BIRTH_NAME: 'NOM DE NAISSANCE :',
    BIRTH_VILLE: 'COMMUNE DE NAISSANCE :',
    CONFIRM_CLOSE: 'Si vous quittez cette page, les changements apportés à vos données personnelles seront annulés.',
    PERSONAL_INFORMATION: 'Mes données personnelles',
    PRIVATE_INFO: 'Elles sont privées et non communiquées.',
    UNIQUENESS: "Ces données permettent de garantir l'unicité de votre compte.",
    USENAME: 'NOM USUEL',
  },
  EMERGENCY_INFORMATION: {
    BACKUPMAIL_UPDATE_SUCCESS: 'Votre email de récupération de secours a bien été mis à jour',
    NEW_MAIL_SUBTEXT: "La nouvelle adresse email sera prise en compte après avoir cliqué sur le lien contenu dans l'email de confirmation.",
    NEW_MAIL_CONFIRM: 'Un email de confirmation a été envoyé à',
    CONFIRM_CLOSE: 'Si vous quittez cette page, les changements apportés à vos informations de secours seront annulés.',
    EMERGENCY_INFORMATION: 'Informations de secours',
    MADAME: 'Madame',
    MONSIEUR: 'Monsieur',
  },
  COLLABORATORS_INFORMATION: {
    COLLABORATORS_INFORMATION: 'Données professionnelles des membres',
    FONCTION: 'Fonction',
    TEL_MOBILE: 'Téléphone mobile professionnel',
    TEL_FIXE: 'Téléphone fixe professionnel',
    DOMAIN: "Domaines d'activité",
    DOMAIN_ERROR: 'Sélectionnez un domaine dans la liste',
    TEL_ERROR: 'Entrez un numéro de téléphone valide',
    MAIL_ERROR: 'Entrez une adresse email valide',
    URL_ERROR: 'Entrez une URL valide',
    NAME_ERROR: 'Entrez un nom valide',
    FIELD_MANDATORY_ERROR: 'Ce champ est obligatoire',
    MAIL_PRO: 'Email professionnel',
    NO_INFO: 'Non renseigné',
    STATUT: 'Statut',
    SALARIE: 'Salarié(e)',
    NONSALARIE: 'Non salarié(e)',
    EDIT: 'Modifier',
  },
  HOME: {
    ADD_SECURITY_LAYER: 'Ajouter un niveau de sécurité supplémentaire',
    ADD_SECURITY_LAYER_SUBTITLE: 'Saisissez votre mot de passe et le code de validation unique qui vous a été envoyé sur votre téléphone.',
    COLLAB_ACCOUNTS: 'Accès des membres',
    COLLAB_INFO: 'Données professionnelles des membres',
    CONFIRM_MODAL_CANCEL: 'Conserver et rester sur la page',
    CONFIRM_MODAL_CONFIRM: 'Annuler et fermer la page',
    CONFIRM_MODAL_TITLE: 'Modifications en cours...',
    DISSOCIATE: 'Dissocier',
    EMERGENCY_INFORMATION: 'Informations de secours',
    EMERGENCY_MAIL: 'Email de récupération de secours',
    DEMANDED_RATTACHEMENT: 'Vous avez envoyé une demande de rattachement à',
    DUPLICATE_RATTACHEMENT_DEMAND: 'La structure est déjà rattachée ou en cours de rattachement',
    FAIL_RATTACHEMENT_DEMAND: 'Impossible de demander le rattachement',
    HARD_AUTH: 'Authentification renforcée',
    HARD_AUTH_CONFIRMATION: "Voulez-vous désactiver l'authentification renforcée ?",
    HARD_AUTH_CONFIRMATION_TITLE: 'Confirmer la désactivation',
    HARD_AUTH_SUBTITLE: "Activez dès maintenant l'authentification renforcée de votre identité numérique",
    SUCCESS_DISOCIATE: 'Votre appareil a bien été dissocier de votre compte.',
    FIND_OTHER_STRUCTURE: 'Rattacher une autre structure',
    FIND_STRUCTURE: 'Rattacher une structure',
    MANAGE_ACCOUNT: 'Gérer mon compte',
    MANAGE_COLLAB_ACCOUNTS: 'Gérer les comptes des membres',
    MANAGE_PRO_INFO: 'Gérer mes informations professionnelles',
    MY_PRO_INFO: 'Mes données professionnelles',
    NO_LINKED_STRUCTURE: "Votre compte  n'est rattaché à aucune structure professionnelle. Veuillez vous rattacher à votre structure afin de pouvoir accéder aux applications de la profession.",
    PAIR_DEVICE: 'Associer un appareil à mon compte',
    PROTECT_ACCOUNT: 'Protéger votre compte des intrus',
    PROTECT_ACCOUNT_SUBTITLE: 'Même si un tiers obtient votre mot de passe, il ne sera pas en mesure de se connecter à votre compte.',
    RECOVER_ACCOUNT: "Récupérez votre compte en cas d'oubli de votre pseudo ou de votre mot de passe.",
    RECOVERY_MAIL: 'Email de récupération',
    REINFORCE_SECURITY: 'Renforcement de la sécurité',
    REINFORCE_SECURITY_SUBTITLE: "Chaque fois que vous vous connecterez à votre compte ID.NOT, vous aurez besoin de votre mot de passe et d'un code de validation.",
    STRUCTURE_INFO: 'Données de la structure',
    UPDATE_MY_PRO_INFO: 'Mettre à jour mes données professionnelles',
    UPDATE_STRUCTURE_INFO: 'Mettre à jour les données de la structure',
    CONSULT_STRUCTURE_INFO: 'Consulter les données de la structure',
    UPDATE_COLLAB_INFO: 'Mettre à jour les données professionnelles des membres',
    UPDATE_COLLAB_STATUT: '! Mettre à jour le statut des collaborateurs (%{number})',
    CONSULT_COLLAB_INFO: 'Consulter les données professionnelles des membres',
    YOUR_DEVICES: 'Vos appareils',

  },
  PAIR_DEVICE: {
    APPLE: "l'App Store",
    CODE_ERROR: 'Impossible de retrouver votre QRCode.',
    CONTINUE: "Une fois l'application installée, vous pouvez continuer.",
    DOWNLOAD_ON: 'Télécharger sur',
    FOLLOW_INSTRUCTIONS: "Puis suivez les instructions affichées sur votre mobile pour finaliser l'association.",
    GOOGLE: 'Google Play',
    INSTRUCTION_END: 'depuis le store de votre téléphone et/ou tablette.',
    INSTRUCTION_START: "Pour associer un ou plusieurs de vos appareils mobiles, vous devez au préalable télécharger l'application",
    INSTRUCTION_QRCODE: "Lancez l'application téléchargée sur votre mobile et scannez le QRCode ci-dessous.",
    APP_NAME: '« TrustBuilder Authenticator »',
    PAIR_DEVICE: "Association d'une protection mobile",
    STEP_ONE: "Etape 1 - Installez l'application « TrustBuilder Authenticator » sur votre mobile.",
    STEP_TWO: 'Etape 2 - Associez votre appareil mobile à votre compte professionnel.',
    SUCCESSFULLY_ADDED: 'Votre appareil a bien été associé à votre compte.',
  },
  PROFESSIONAL_INFORMATION: {
    CONFIRM_SUBMIT_TITLE: 'Vos informations vont être mises à jour',
    CONFIRM_SUBMIT_SUBTITLE: 'Conformément à notre politique de partage de données, ces modifications seront partagées avec '
        + 'des acteurs de la profession, publiées sur le site '
        + '<a target="_blank" href="https://notaires.fr">https://notaires.fr</a> '
        + 'et pourraient être publiées sur d\'autres sites de la profession.',
    CONFIRM_CLOSE: 'Si vous quittez cette page, les changements apportés à vos données professionnelles seront annulés.',
    MANAGER: "Vous êtes gestionnaire de cette structure, vous avez la possibilité d'administrer les accès des collaborateurs et de mettre à jour les données de la structure.",
    PROFESSIONAL_INFORMATION: 'Mes données professionnelles',
    PUBLIC_INFORMATION: "Ces données sont publiques et sont affichées dans l'annuaire de la profession",
    SPOKEN_LANGUAGES: 'Langues parlées',
    LANG_NOTINLIST: 'Veuillez sélectionner un langage dans la liste',
    DOMAINE_NOTINLIST: "Veuillez sélectionner un domaine d'activité dans la liste",
    CONFIRM_LANG1: 'Voulez-vous ajouter',
    CONFIRM_LANG2: 'à vos langues parlées ?',
    CONFIRM_DOMAIN2: "à vos domaines d'activité ?",
  },
  STRUCTURE_INFORMATION: {
    UPDATE_SUCCESS: 'Les données de la structure ont été mises à jour',
    CONFIRM_CLOSE: 'Si vous quittez cette page, les changements apportés à la structure seront annulés.',
    CONFIRM_BUREAU_CHANGE: 'Si vous changez de bureau, les changements apportés seront annulés.',
    CONFIRM_CHANGE: 'Changer de bureau',
    CLOSED: 'Fermé',
    ACCESSIBILITY: 'Accessibilité',
    GENERAL_INFOS: 'Informations générales',
    STRUCTURE_CONTACT: 'Contact de la structure',
    TELEPHONE: 'Téléphone',
    EMAIL: 'Email',
    SITE: 'Site internet',
    STRUCTURE_INFORMATION: 'Données %{typeEntity}',
    PARKING: 'Parking',
    ELEVATOR: 'Ascenseur',
    HANDICAP: 'Accès handicapés',
    STRUCTURE_ADDRESS: 'Adresse géographique',
    STRUCTURE_POSTAL_ADDRESS: 'Adresse postale',
    OPENING_HOURS: "Horaires d'ouverture",
    ADD_HOURS: 'Ajouter une plage horaire',
    BATIMENT: 'Entrée - Bâtiment - Immeuble',
    ADRESSE: 'Numéro et libellé de la voie',
    CODE_POSTAL: 'Code postal',
    CODE_POSTAL_INVALID: 'Le code postal n\'est pas valide',
    VILLE: 'Ville',
    COMPLEMENT: "Complément d'adresse",
    NAME_PLACEHOLDER: 'Nom de la structure',
    ROWS: {
      ID: 'Identifiant ID.NOT',
      TYPE: 'Type',
      FORME_JURIDIQUE: 'Forme juridique',
      STATUT: 'Statut',
      DEPARTMENT: 'Département de résidence',
      RESIDENCE: 'Résidence',
      DEPARTMENT_COUVERTS: 'Départements couverts',
    },
    DAYS: {
      Lundi: 'Lundi :',
      Mardi: 'Mardi :',
      Mercredi: 'Mercredi :',
      Jeudi: 'Jeudi :',
      Vendredi: 'Vendredi :',
      Samedi: 'Samedi :',
      Dimanche: 'Dimanche :',
    },
  },
  PLACEHOLDER: {
    NOMAIL: '-',
  },
  actions: {
    ADD: 'Ajouter',
    BACK: 'Retour',
    CLOSE: 'Fermer',
    CANCEL: 'Annuler',
    SAVE: 'Enregistrer',
    DELETE: 'Supprimer',
    NEW: 'Nouveau',
    CONFIRM: 'Confirmer',
    SEARCH: 'Rechercher',
    NEXT: 'Suivant',
    CONTINUE: 'Continuer',
    END: 'Terminer',
    RETRY: 'Recommencer',
    VALIDATE: 'Valider',
    DETACH: 'Se détacher de la structure',
  },
  VALIDATION: {
    PSEUDO: {
      LENGTH: 'L\'identifiant doit contenir 6 caractères minimum (chiffres, lettres sans accent, caractère "." ou "-" ou "_".',
      IDN: 'L\'identifiant ne doit pas commencer par IDN.',
      PATTERN: 'L\'identifiant n\'est pas du bon format. Essayez prenom.nom',
    },
    PASSWORD: {
      CURRENT_EMPTY: 'Veuillez renseigner votre ancien mot de passe',
      UNFIT: 'Le mot de passe ne répond pas à l\'ensemble des règles de sécurité',
      CONFIRM_PASSWORD: 'Veuillez confirmer votre nouveau mot de passe',
      CONFIRM_DIFFERENT: 'Les mots de passe sont différents',
    },
  },
  message: {
    SUCCESS: 'Les modifications ont bien été prises en compte',
    ERROR_MODIF: 'Les modifications ont échoués',
    YES: 'Oui',
    NO: 'Non',
    ERROR: 'Une erreur est survenue',
    RETRY_PROCESS: 'Veuillez recommencer la procédure de changement d\'e-mail.',
  },
  wsError: {
    INTERNAL_ERROR: 'Erreur de connexion',
    SERVER_CONNECTION: 'Impossible de se connecter au serveur HTTPS',
    AUTHENTIFICATION_EXPIRED: 'Session d\'administration expirée',
    FIELD_REQUIRED: 'Le champ \'%{field0}\' est requis',
    COLOR_INVALID: 'Le champ \'%{field0}\' doit être une couleur au format hexadecimale : #ff00ff',
    EMAIL_INVALID: 'L\'adresse e-mail \'%{field0}\' n\'est pas valide',
    USERNAME_ALREADY_EXISTS: 'Cet identifiant est déjà utilisé sur un autre compte, veuillez en choisir un autre',
    EMAIL_ALREADY_EXISTS: 'Cette adresse e-mail est déjà utilisée sur un autre compte, veuillez en choisir une autre',
    PASSWORDS_DIFFERENT: 'Les mots de passe \'%{field0}\' et \'%{field1}\' doivent être identiques',
    WRONG_LOGIN_OR_PASSWORD: 'Nom d\'utilisateur ou mot de passe incorrect',
    TOO_MANY_WRONG_ATTEMPS: 'Suite à des erreurs dans la saisie de vos identifiants, votre compte est verrouillé pendant %{field0} minutes, veuillez-vous reconnecter ultérieurement',
    ROLE_LABEL_EXISTS: 'Il existe déjà un rôle avec ce libellé',
    PASSWORD_TOO_SHORT: 'Le mot de passe est trop court, il doit faire au moins %{field0} caractères',
    MESSAGE: '%{field0}',
    ENTI_05_ERR_13: 'L\'image de profil ne doit pas dépasser 1Mo.',
  },
  date: {
    long: 'DD MMMM YYYY HH:mm',
    DATE_START: 'Date de début',
    DATE_END: 'Date de fin',
    DATE_FORMAT: 'DD/MM/YYYY',
  },
  collaborators: {
    tooltip: {
      infos: 'Mettre à jour les données des membres',
      filters: 'Filtrer',
    },
    blockedAccount: 'Compte bloqué',
    back: 'Gestion des comptes des membres',
    collaborator: 'Collaborateur',
    title: '%{name} - %{number} membres',
    rights: 'Droits',
    fonction: 'Fonction',
    gestionnaires: 'Gestionnaire(s) (%{number})',
    gestionnaireDesc: 'Les gestionnaires naturels de la structure peuvent : déléguer ou révoquer les droits de gestion à leurs collaborateurs, bloquer ou débloquer les accès des collaborateurs à la structure et déclarer le départ des collaborateurs ne faisant plus partie de la structure.',
    gestionnaireDelegate: 'Gestionnaire(s) délégué(s) (%{number})',
    gestionnaireDelegateDesc: 'Les gestionnaires délégués ont reçu des droits de gestion de la part d\'un gestionnaire de l\'office.',
    collaborators: 'Membres (%{number})',
    collaboratorsDesc: 'Ces membres ne disposent d\'aucun droit de gestion.',
    noRight: 'Aucun droit de gestion (%{number})',
    invitation: {
      button: 'Inviter un membre',
      sent: 'Invitation envoyée',
      expired: 'Invitation expirée',
      rejected: 'Invitation refusée',
      creation: 'le %{date} à %{time}',
      active: 'Encore active %{hours} h %{minutes} min',
      popin: {
        title: 'Inviter un membre à rejoindre la structure',
        desc: 'Renseignez les informations du membre à inviter :',
        warning: 'Attention, veillez à renseigner une adresse email personelle et non générique.',
        send: 'Envoyer l\'invitation',
        info: 'Cette invitation est valable pendant 72 heures',
        timeRemaining: 'Cette invitation est encore valable pendant %{heures} heures',
        confirmation: 'Souhaitez-vous continuer ?',
        expired: 'Cette invitation est expirée',
      },
      CONFIRMATION: {
        title: 'Invitation envoyée !',
        desc: 'Une invitation a rejoindre la structure %{entity} a été envoyé à :',
      },
      DELETE: {
        title: 'Suppression de l\'invitation',
        desc: 'Vous êtes sur le point de supprimer l\'invitation',
        button: 'Supprimer l\'invitation',
        success: 'L\'invitation a bien été supprimée.',
      },
      RENEW: {
        title: 'Renouveler l\'invitation',
        desc: 'Vous êtes sur le point de renouveler l\'invitation pour 72 heures.',
        button: 'Renouveler l\'invitation',
        success: 'L\'invitation a bien été renouvelée.',
      },
      form: {
        lastname: 'Nom',
        firstname: 'Prénom',
        gender: 'Civilité',
        email: 'Email',
      },
    },
    blockModal: {
      title: 'Confirmez le bloquage',
      subTitle: 'Vous êtes sur le point de confirmer le bloquage de',
      titleSelected: 'Confirmez le débloquage',
      subTitleSelected: 'Vous êtes sur le point de confirmer le débloquage de',
      tooltip: 'Bloquer',
      tooltipSelected: 'Débloquer',
    },
    delegateModal: {
      title: 'Confirmez la délégation',
      subTitle: 'Vous êtes sur le point de confirmer le passage en gestionnaire délégué de',
      titleSelected: 'Confirmez la révocation',
      subTitleSelected: 'Vous êtes sur le point de confirmer la révocation de droit de',
      tooltip: 'Déléguer mes droits',
      tooltipSelected: 'Révoquer les droits',
    },
    leaveModal: {
      title: 'Confirmez le départ',
      subTitle: 'Vous êtes sur le point de confirmer le depart de l\'office de',
      tooltip: 'Déclarer un depart',
    },
  },
  enrolement: {
    expired: 'L\'invitation a expiré.',
    expiredInfo: 'Veuillez vous rapprocher du gestionnaire de la structure %{entity} pour recevoir une nouvelle invitation.',
    invalid: 'Le lien est invalide.',
    invalidInfo: 'Veuillez contacter le gestionnaire de la structure %{entity} pour renouveler l\'invitation.',
    title: 'Votre invitation à rejoindre la structure "%{entity}"',
    hello: 'Bonjour %{prenom} %{nom},',
    continue: 'Vous avez été invité à rejoindre la structure "%{entity}". Pour continuer :',
    account: {
      title: 'Je possède un compte ID.not',
      desc: 'Connectez-vous, votre compte sera automatiquement rattaché à la structure.',
    },
    noAccount: {
      title: 'Je n\'ai pas de compte ID.not',
      desc: 'Créez votre compte en 3 étapes. Laissez-vous guidez, c\'est simple !',
      button: 'Créer mon compte ID.not',
    },
    refuse: {
      title: 'Je refuse l\'invitation',
      desc: 'Vous ne souhaitez pas rejoindre la structure. Déclinez l\'invitation.',
      button: 'Décliner l\'invitation',
      success: 'Invitation refusée avec succès',
      modal: {
        title: 'Décliner l\'invitation',
        desc: 'Vous êtes sur le point de refuser l\'invitation à rejoindre la structure Coreoz. Cette opération est irréversible.',
        confirm: 'Souhaitez-vous continuer ?',
      },
    },
    notify: 'Votre compte est désormais rattaché à la structure %{entity}.',
  },
  rattachement: {
    success: 'Le collaborateur a bien été rattaché à votre structure',
    pending: 'Rattachement en cours, en attente de validation...',
    blocked: 'Compte bloqué',
    modal: {
      validate: {
        title: 'Confirmer la demande de rattachement',
        subTitle: 'Vous êtes sur le point de confirmer la demande de rattachement de',
        precision: 'Précisez s\'il s\'agit d\'un collaborateur :',
        salarie: 'Salarié',
        nonSalarie: 'Non salarié',
      },
      refuse: {
        title: 'Confirmer le refus de rattachement',
        subTitle: 'Vous êtes sur le point de refuser la demande de rattachement de',
      },
    },
    tile: {
      rattacher: 'Rattacher',
      refuse: 'Refuser',
      refusedBy: 'Refusée le %{date} par %{name}',
    },
    demande: 'Gestion des demandes de rattachement',
    RefusedDemande: 'Demandes de rattachement refusées',
    pendingRattachement: 'Demandes de rattachement en attente (%{number})',
    noPendingRattachement: 'Aucune demande de rattachement en attente.',
    collaboratorsDemande: 'Les collaborateurs ci-dessous ont fait une demande de rattachement à votre office. En acceptant leur demande, vous leur donnez accès aux applications de la profession. Vérifiez que ces collaborateurs appartiennent bien à votre office.',
    refusedDemand: 'Demandes de rattachement refusées (%{number})',
    noRefusedDemand: 'Aucune demande de rattachement refusée.',
    refusedDemandSubtitle: 'Les demandes de rattachement ci-dessous ont été refusées par un gestionnaire de l\'office. Ces demandes sont valables 30 jours puis seront définitivement supprimées.',
    DELETE_DEMAND: 'Supprimer la demande',
    DELETE: 'Supprimer la demande de rattachement',
    SUBTITLE_DELETE: 'Confirmez la suppression de votre demande de rattachement à %{entite}.',
    DETACH: 'Supprimer le rattachement',
    SUBTITLE_DETACH: 'Confirmez votre détachement de la structure %{entite}.',
  },
  NO_RESULT: 'Pas de résultat.',
  input: {
    picture: 'Choisissez une image',
    subtitle: 'Cliquez sur l\'image pour la modifier',
  },
  ACCOUNT_ACTIVATED: {
    TITLE: 'Votre compte a déjà été activé',
  },
  CONTACT: {
    title: 'Contacter la hotline',
  },
  ACTIVATION_LINK: {
    MDP: 'Veuillez renseigner un mot de passe : ',
    EXPIRED: 'Votre lien a expiré',
    ACTIVATED: 'Félicitations, votre compte ID.NOT est désormais activé.',
  },
  EMAIL_MODIFICATION: {
    SUCCESS: 'Félicitations, votre compte ID.NOT a été mis à jour avec succès.',
    INVALID: 'Le lien est invalide.',
    EXPIRED: 'Le lien a expiré.',
    UNKNOWN: 'Une erreur inconnue est arrivée.',
  },
};

export default fr;
